(() => {
  const routeRoot = window.Shopify?.routes?.root || '/';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const lock = () => document.body.classList.add('is-locked');
  const unlock = () => setTimeout(() => {
    if (![...document.querySelectorAll('dialog')].some((dialog) => dialog.open)) document.body.classList.remove('is-locked');
  }, 0);

  hydrateCatalogBestSellers(document);

  document.addEventListener('click', async (event) => {
    const announcementDismiss = event.target.closest('[data-announcement-dismiss]');
    if (announcementDismiss) announcementDismiss.closest('[data-announcement-item]')?.remove();

    const open = event.target.closest('[data-open-dialog]');
    if (open) {
      const dialog = document.getElementById(open.dataset.openDialog);
      if (dialog) { dialog.showModal(); lock(); setTimeout(() => dialog.querySelector('input')?.focus(), 50); }
    }
    const close = event.target.closest('[data-close-dialog]');
    if (close) document.getElementById(close.dataset.closeDialog)?.close();
    if (event.target instanceof HTMLDialogElement) event.target.close();

    const quickTrigger = event.target.closest('[data-quick-trigger]');
    if (quickTrigger) {
      if (quickTrigger.dataset.variantId) await addToCart(quickTrigger.dataset.variantId, 1, quickTrigger);
      else {
        const card = quickTrigger.closest('[data-product-card]');
        document.querySelectorAll('[data-product-card].is-quick-open').forEach((item) => {
          if (item === card) return;
          item.classList.remove('is-quick-open');
          item.querySelector('[data-quick-trigger]')?.setAttribute('aria-expanded', 'false');
          item.querySelector('.product-card__quick')?.setAttribute('aria-hidden', 'true');
        });
        card.classList.toggle('is-quick-open');
        quickTrigger.setAttribute('aria-expanded', card.classList.contains('is-quick-open'));
        card.querySelector('.product-card__quick')?.setAttribute('aria-hidden', String(!card.classList.contains('is-quick-open')));
      }
    }
    const quickClose = event.target.closest('[data-quick-close]');
    if (quickClose) {
      const card = quickClose.closest('[data-product-card]');
      card.classList.remove('is-quick-open');
      card.querySelector('[data-quick-trigger]')?.setAttribute('aria-expanded', 'false');
      card.querySelector('.product-card__quick')?.setAttribute('aria-hidden', 'true');
    }
    const quickSize = event.target.closest('.quick-add__size[data-variant-id]');
    if (quickSize) await addToCart(quickSize.dataset.variantId, 1, quickSize);

    const cartChange = event.target.closest('[data-cart-change]');
    if (cartChange) {
      cartChange.disabled = true;
      await fetch(`${routeRoot}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(cartChange.dataset.cartChange), quantity: Number(cartChange.dataset.quantity) }) });
      await refreshCart();
    }

    const option = event.target.closest('[data-product-option]');
    if (option) {
      const scope = option.closest('[data-product-form]');
      scope.querySelectorAll(`[data-option-position="${option.dataset.optionPosition}"]`).forEach((button) => button.classList.remove('is-selected'));
      option.classList.add('is-selected');
      const selectedLabel = option.closest('.product-option')?.querySelector('[data-option-selected]');
      if (selectedLabel) selectedLabel.textContent = option.dataset.optionValue;
      updateVariant(scope);
    }
    const quantity = event.target.closest('[data-quantity-change]');
    if (quantity) {
      const input = quantity.parentElement.querySelector('input');
      input.value = Math.max(1, Number(input.value) + Number(quantity.dataset.quantityChange));
    }
    const stickyAtc = event.target.closest('[data-sticky-atc]');
    if (stickyAtc) document.getElementById(stickyAtc.dataset.stickyAtc)?.requestSubmit();

    const loadMore = event.target.closest('[data-load-more]');
    if (loadMore) {
      loadMore.disabled = true;
      loadMore.classList.add('is-loading');
      try {
        const response = await fetch(loadMore.dataset.nextUrl);
        if (!response.ok) throw new Error('Unable to load more products');
        const html = await response.text();
        const nextDocument = new DOMParser().parseFromString(html, 'text/html');
        const nextCards = nextDocument.querySelectorAll('[data-product-grid] > .product-card');
        const collectionProducts = loadMore.closest('.collection-products');
        const grid = collectionProducts?.querySelector('[data-product-grid]');
        if (!grid || !nextCards.length) throw new Error('No additional products found');
        nextCards.forEach((card) => grid.append(card));
        const status = collectionProducts?.querySelector('[data-load-more-status]');
        if (status) status.textContent = loadMore.dataset.loadedMessage.replace('[count]', nextCards.length);
        const nextButton = nextDocument.querySelector('[data-load-more]');
        if (nextButton) loadMore.dataset.nextUrl = nextButton.dataset.nextUrl;
        else loadMore.remove();
      } catch (error) {
        console.error(error);
      } finally {
        if (loadMore.isConnected) {
          loadMore.disabled = false;
          loadMore.classList.remove('is-loading');
        }
      }
    }
  });

  document.addEventListener('close', unlock, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form] form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const data = new FormData(form);
    await addToCart(data.get('id'), data.get('quantity') || 1, button);
  });

  document.addEventListener('shopify:section:load', (event) => hydrateCatalogBestSellers(event.target));

  let searchTimer;
  const searchInput = document.querySelector('[data-search-input]');
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const query = searchInput.value.trim();
    if (query.length < 2) { document.querySelector('[data-search-results]').innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      const response = await fetch(`${routeRoot}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`);
      const payload = await response.json();
      document.querySelector('[data-search-results]').innerHTML = payload.resources.results.products.map((product) => `<a class="search-result" href="${product.url}">${product.image ? `<img src="${product.image}" alt="">` : ''}<span>${product.title}</span></a>`).join('');
    }, 180);
  });

  async function addToCart(id, quantity, button) {
    if (!id) return;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      const response = await fetch(`${routeRoot}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] }) });
      if (!response.ok) throw new Error('Unable to add item');
      await refreshCart();
      const drawer = document.getElementById('CartDrawer');
      if (!drawer.open) { drawer.showModal(); lock(); }
    } catch (error) {
      console.error(error);
    } finally {
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    }
  }

  async function refreshCart() {
    const response = await fetch(`${routeRoot}cart.js`);
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((node) => node.textContent = cart.item_count);
    const body = document.querySelector('[data-cart-body]');
    let footer = document.querySelector('[data-cart-footer]');
    if (!body) return;
    if (!cart.items.length) {
      const emptyTemplate = document.querySelector('[data-cart-empty-template]');
      body.innerHTML = emptyTemplate?.innerHTML || '';
      footer?.remove();
      return;
    }
    body.innerHTML = cart.items.map((item, index) => `<article class="cart-item"><a href="${item.url}">${item.image ? `<img src="${item.image}" alt="">` : ''}</a><div><a class="cart-item__title" href="${item.url}">${item.product_title}</a><div class="cart-item__variant">${item.variant_title || ''}</div><div class="cart-item__bottom"><div class="cart-item__quantity"><button type="button" data-cart-change="${index + 1}" data-quantity="${item.quantity - 1}">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${index + 1}" data-quantity="${item.quantity + 1}">+</button></div><span>${money(item.final_line_price)}</span></div></div></article>`).join('');
    if (!footer) {
      const footerTemplate = document.querySelector('[data-cart-footer-template]');
      document.querySelector('[data-cart-drawer] .drawer__inner').append(footerTemplate.content.cloneNode(true));
      footer = document.querySelector('[data-cart-footer]');
    }
    updateCartFooter(cart, footer);
  }

  function updateCartFooter(cart, footer) {
    if (!footer) return;
    footer.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    const drawer = document.querySelector('[data-cart-drawer]');
    const threshold = Number(drawer?.dataset.freeShippingThreshold || 0);
    const shipping = footer.querySelector('[data-cart-shipping]');
    if (!shipping || threshold <= 0) return;
    shipping.hidden = false;
    const message = shipping.querySelector('[data-cart-shipping-message]');
    const remaining = Math.max(0, threshold - cart.total_price);
    message.textContent = remaining === 0 ? message.dataset.unlockedLabel : message.dataset.remainingLabel.replace('[amount]', money(remaining));
    shipping.querySelector('[data-cart-progress]').style.width = `${Math.min(100, (cart.total_price / threshold) * 100)}%`;
  }

  function hydrateCatalogBestSellers(scope) {
    scope.querySelectorAll('[data-catalog-best-sellers-url]').forEach(async (rail) => {
      rail.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(rail.dataset.catalogBestSellersUrl);
        if (!response.ok) return;
        const html = await response.text();
        const source = new DOMParser().parseFromString(html, 'text/html');
        const limit = Number(rail.dataset.productsToShow) || rail.children.length;
        const cards = [...source.querySelectorAll('[data-product-grid] > .product-card')].slice(0, limit);
        if (cards.length) rail.replaceChildren(...cards);
      } catch (_error) {
        return;
      } finally {
        rail.removeAttribute('aria-busy');
      }
    });
  }

  function updateVariant(scope) {
    const selected = [...scope.querySelectorAll('[data-product-option].is-selected')].sort((a,b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((button) => button.dataset.optionValue);
    const variants = JSON.parse(scope.querySelector('[data-product-variants]').textContent);
    const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
    if (!variant) return;
    scope.querySelector('input[name="id"]').value = variant.id;
    const submit = scope.querySelector('form[action*="/cart/add"] [type="submit"]');
    submit.disabled = !variant.available;
    submit.querySelector('[data-atc-label]').textContent = variant.available ? submit.dataset.availableLabel : submit.dataset.soldLabel;
    scope.querySelectorAll('[data-product-price]').forEach((price) => price.textContent = money(variant.price));
    const sticky = scope.querySelector('[data-sticky-atc]');
    if (sticky) sticky.disabled = !variant.available;
    scope.querySelector('[data-back-in-stock]')?.classList.toggle('is-hidden', variant.available);
    const colorOption = scope.querySelector('.swatch-list [data-product-option].is-selected');
    if (colorOption && scope.querySelector('[data-product-color]')) scope.querySelector('[data-product-color]').textContent = colorOption.dataset.optionValue;
    history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  }
})();
